import { Transform } from "class-transformer";
import type { AnchorElement } from "../../../core/AnchorElement";
import type { EInsideElement } from "../../../core/EInsideElement";
import type { FrontFace } from "../../../core/FrontFace";
import { Length } from "../../../core/Length/Length";
import type { OffsetElement } from "../../../core/OffsetElement";
import type { IDrawCabinetInsideElement } from "./IDrawCabinetInsideElement";
import { LengthParser } from "../../../core/Length/LengthParser";

export class DrawCabinetInsideElement implements IDrawCabinetInsideElement {
    TypeName: string = this.constructor.name;
    Type!: EInsideElement;
    
    @Transform(params => LengthParser.parse(params.value))
    Height!: Length;
    @Transform(params => LengthParser.parse(params.value))
    Width!: Length;
    @Transform(params => LengthParser.parse(params.value))
    Depth!: Length;

    Face?: FrontFace;
    Anchor!: AnchorElement;
    Offset!: OffsetElement;

    toFlatHierarchy(): IDrawCabinetInsideElement[] {
        return [this];
    }
}
